import { render, staticRenderFns } from "./eventOrLesson.vue?vue&type=template&id=61bd66b0&scoped=true&"
import script from "./eventOrLesson.vue?vue&type=script&lang=js&"
export * from "./eventOrLesson.vue?vue&type=script&lang=js&"
import style0 from "./eventOrLesson.vue?vue&type=style&index=0&id=61bd66b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd66b0",
  null
  
)

export default component.exports